import { NgModule } from '@angular/core';
import { DataConnectModule } from '@epicuro-next/data/connect';
import { SessionStateModule } from '@epicuro-next/state/session-state';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ConnectTokenEffects } from './state/connect-token.effects';
import {
  connectTokenFeatureKey,
  initialState,
  reducer,
} from './state/connect-token.reducer';
import { resetStateMetaReducer } from '@epicuro-next/state/meta-reducers';

@NgModule({
  imports: [
    StoreModule.forFeature(connectTokenFeatureKey, reducer, {
      metaReducers: [resetStateMetaReducer(initialState)],
    }),
    EffectsModule.forFeature([ConnectTokenEffects]),
    DataConnectModule,
    SessionStateModule,
  ],
})
export class ConnectTokenStateModule {}
